import CheckCircle from "@mui/icons-material/CheckCircle"
import { Box, Chip, Rating, Stack, Tooltip, Typography } from "@mui/material"
import { formatDistanceToNow } from "date-fns"
import React from "react"
import { ReviewCardProps } from "./types"

export const ReviewContent = ({ title, body, reviewer, rating, created_at, verified }: Omit<ReviewCardProps, 'cardProps'>) => {
    // const id = useId()

    const distToNow = formatDistanceToNow(new Date(created_at), { addSuffix: true }) + '';

    return (
        <Stack gap={2} justifyContent={{ xs: "flex-start", sm: "flex-start", md: "space-between" }} sx={{ height: '100%' }}>
            <Stack gap={3}>
                <Stack direction="column" gap={1}>
                    <Typography variant="h5" component={"h2"} fontSize={"16px"}>{title}</Typography>
                    <Stack direction="row" justifyContent={'space-between'}>
                        <Typography component={'div'} variant="caption">{distToNow}</Typography>
                        {verified ? <Tooltip title="Verified by judge.me"><Chip size="small" variant="outlined" label="Verified" color="success" icon={<CheckCircle />} /></Tooltip> : <Box></Box>}
                    </Stack>
                </Stack>

                <Typography variant="body1" color="textPrimary">{body}</Typography>
            </Stack>

            <Stack direction="row" justifyContent={'space-between'}>
                <Typography variant="subtitle1" component={"div"} color="textSecondary">{reviewer.name}</Typography>
                <Tooltip title={`Rated ${rating} out of 5`}>
                    <Box><Rating
                        size="small"
                        precision={0.2}
                        readOnly
                        value={rating}
                    /></Box>
                </Tooltip>
            </Stack>
        </Stack>
    )
}